// components/Projects.jsx
// import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

const ProjectCard = ({ project }) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
      <div className="bg-primary h-48 flex items-center justify-center">
        <h3 className="text-2xl font-bold text-white">{project.title}</h3>
      </div>
      <div className="p-6">
        <p className="text-gray-700 mb-4">{project.description}</p>
        <div className="mb-4">
          <h4 className="text-sm font-bold text-gray-600 mb-2">TECHNOLOGIES</h4>
          <div className="flex flex-wrap gap-2">
            {project.technologies.map((tech, index) => (
              <span 
                key={index}
                className="bg-gray-100 text-primary px-3 py-1 rounded-full text-sm"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
        <div className="flex space-x-3">
          {project.github && (
            <a 
              href={project.github} 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-gray-800 text-white px-4 py-2 rounded-md flex items-center text-sm hover:bg-gray-700 transition-colors"
            >
              <FaGithub className="mr-2" /> GitHub
            </a>
          )}
          {project.live && (
            <a 
              href={project.live} 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-primary text-white px-4 py-2 rounded-md flex items-center text-sm hover:bg-opacity-90 transition-colors"
            >
              <FaExternalLinkAlt className="mr-2" /> Live Demo
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

const Projects = () => {
  const projects = [
    {
      title: "DriveWise - Vehicle Maintenance App",
      description: "A mobile app for vehicle maintenance with personalized schedules, product recommendations, and OBD sensor integration for real-time diagnostics.",
      technologies: ["Flutter", "Dart", "Node.js", "MongoDB", "JavaScript"],
      github: "#",
      live: null,
    },
    {
      title: "Real-Time Event Ticketing System",
      description: "Implemented an Object-Oriented based program for event ticket booking system and it's a real-time booking system that uses multithreading and synchronization.",
      technologies: ["Java", "React.js", "SpringBoot", "MySQL"],
      github: "#",
      live: null,
    },
    {
      title: "GreenCanopy Initiative Website",
      description: "Developed responsive frontend interface using core web technologies.",
      technologies: ["HTML", "CSS", "JavaScript"],
      github: "#",
      live: null,
    },
    {
      title: "Student Progression Prediction System",
      description: "A Python-based Progression Prediction system with two interfaces: one for students to predict their own progress, and another for staff to predict progression for all students.",
      technologies: ["Python"],
      github: "#",
      live: null,
    },
    {
      title: "Plane Seat Management System",
      description: "Implemented a Java program for a Plane booking system, which includes a ticket reservation system, seat availability display, file management, and seat sorting according to the customer's choice.",
      technologies: ["Java"],
      github: "#",
      live: null,
    },
  ];

  return (
    <section id="projects" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-2">My Projects</h2>
          <div className="w-24 h-1 bg-primary mx-auto"></div>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Here are some projects I've worked on that showcase my skills and experience.
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <ProjectCard project={project} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;